import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

const CustomBreadcrumbs = (props) => {
  const { title, subtitle } = props;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="medium" />}
      aria-label="breadcrumb"
      sx={{ fontSize: 18, color: '#64748b' }}
    >
      <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />

      <Typography
        color="text.primary"
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          color="text.primary"
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 500,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
